function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function normalizeHex(hex) {
  if (!hex || typeof hex !== "string") return "#1a73e8";
  const trimmed = hex.trim();
  if (!trimmed.startsWith("#")) return "#1a73e8";

  if (trimmed.length === 4) {
    const r = trimmed[1];
    const g = trimmed[2];
    const b = trimmed[3];
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }

  if (trimmed.length === 7) return trimmed.toLowerCase();
  return "#1a73e8";
}

export function withAlpha(hex, alpha) {
  const safe = normalizeHex(hex);
  const a = clamp(alpha, 0, 1);
  const r = parseInt(safe.slice(1, 3), 16);
  const g = parseInt(safe.slice(3, 5), 16);
  const b = parseInt(safe.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export function getOnboardingThemeTokens({ darkMode, templateTheme }) {
  const primary = normalizeHex(templateTheme?.payload?.primaryColor || "#1a73e8");
  const background = normalizeHex(templateTheme?.payload?.backgroundColor || "#f0f2f5");

  return {
    primary,
    background,
    canvas: darkMode ? "#0f172a" : "#f8f9fa",
    gradientEnd: darkMode ? "#111827" : "#ffffff",

    panelBg: darkMode ? "rgba(15, 23, 42, 0.72)" : "rgba(255, 255, 255, 0.78)",
    panelBorder: darkMode ? "rgba(148, 163, 184, 0.22)" : "rgba(255, 255, 255, 0.42)",
    panelShadow: darkMode
      ? "0 10px 34px 0 rgba(2, 6, 23, 0.55)"
      : "0 8px 30px 0 rgba(15, 23, 42, 0.12)",

    softSurface: darkMode ? "rgba(148, 163, 184, 0.10)" : "rgba(15, 23, 42, 0.03)",
    softSurfaceStrong: darkMode ? "rgba(148, 163, 184, 0.14)" : "rgba(15, 23, 42, 0.06)",
    borderSubtle: darkMode ? "rgba(148, 163, 184, 0.30)" : "rgba(15, 23, 42, 0.12)",
    divider: darkMode ? "rgba(148, 163, 184, 0.24)" : "rgba(15, 23, 42, 0.08)",

    textStrong: darkMode ? "#f8fafc" : "#1e293b",
    textMuted: darkMode ? "rgba(226, 232, 240, 0.78)" : "rgba(30, 41, 59, 0.78)",

    focusRing: withAlpha(primary, darkMode ? 0.35 : 0.2),
    primarySoft: withAlpha(primary, darkMode ? 0.22 : 0.12),
    primarySoftStronger: withAlpha(primary, darkMode ? 0.28 : 0.18),
    glowSoft: darkMode
      ? "0 8px 16px rgba(34, 197, 94, 0.25)"
      : "0 8px 16px rgba(34, 197, 94, 0.18)",
  };
}
